import React from 'react';
import type { CtaDockConfig } from './ctaDockStyle';

/**
 * Обёртка прибитой нижней кнопки (пак `cta.placement: 'fixed-bottom'`).
 * Разметка — класс `.qb-cta-dock` в styles/public-paywall.css: `fixed` у низа
 * окна, кнопка в `bottomPx` от края (эталон 20), подложка по `data-surface`,
 * от 920 px — без фона, низ 32 (у 'solid' — 26); свой отступ поля воронки
 * (`exactBottom`) — нижним полем на самой панели, его правило 920 px не
 * перебивает. Перед обёрткой — невидимый
 * запас высотой `reservePx`, чтобы конец контента не прятался под кнопкой.
 *
 * В канве конструктора (`preview`) окна нет — обёртка липкая (`sticky`) внутри
 * рамки телефона, без запаса: `fixed` уехал бы к низу окна редактора.
 */
export function CtaDock({
  config,
  canScroll,
  preview,
  children,
}: {
  config: CtaDockConfig;
  canScroll: boolean;
  preview: boolean;
  children: React.ReactNode;
}) {
  return (
    <>
      {preview ? null : (
        <div
          aria-hidden="true"
          data-testid="quiz-cta-reserve"
          style={{ height: config.reservePx, flexShrink: 0 }}
        />
      )}
      <div
        className="qb-cta-dock"
        data-testid="quiz-cta-dock"
        data-surface={config.surface}
        data-scrolled={canScroll ? 'true' : 'false'}
        data-preview={preview ? 'true' : undefined}
        style={
          {
            '--cta-bottom': `${config.bottomPx}px`,
            // Свой отступ поля воронки — ровно он и на широком окне.
            ...(config.exactBottom ? { paddingBottom: config.bottomPx } : {}),
          } as React.CSSProperties
        }
      >
        {children}
      </div>
    </>
  );
}
